import React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import API from "../../Services/BaseService";
import "../../Component/CommonPopup/commonPopup.css";
import PageNotFound from '../FallBackUI/PageNotFound';
import Loading from "../../Component/Loading/Loading";
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const ProxyBid = (props) => {


    const [loading, setLoading] = useState(true);

    const sellerData = useSelector(state => state.LoginReducer.payload);


    const [dealerList, setDealerList] = useState("");
    console.log("dealerList", dealerList)
    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);
    useEffect(() => {
        BidList();

    }, []);


    const BidList = () => {

        let request = {
            car_id: props.carId,
            seller_id: sellerData.seller_id,
            seller_token: sellerData.seller_token,
        }
        API.post("proxybidlist/condition", request).then(response => {
            if (response.data.success === true) {

                setLoading(false);
                setDealerList(response.data.data);
                console.log("setDealerList", response.data.data);

            }

            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }


        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                }
            });
    }

    function formatTime(value) {
        if (value != "" && value != null && value != undefined) {
            let local = ""
            let offset = ""
            local = new Date(value);
            offset = local.getTimezoneOffset();
            value = new Date(local.getTime() - offset * 60000);
            value = moment(value).format('MMMM D, YYYY hh:mm A')
            return value;
        }
    }



    return (

        <div>
            <Modal show={true} onHide={props.toggle} size="lg" /* backdrop="static" keyboard={false} */>
                <Modal.Header className='Terms-login'>
                    <h2 >Proxy Bid Details</h2>
                </Modal.Header>
                <Modal.Body>
                    {errorFlag === true ? <PageNotFound error={errors} /> :
                        <>

                            {loading ? <Loading /> :

                                <div style={{ overflowX: 'auto' }}>
                                    <table class="bidinfo-table">
                                        <thead className='Bidlist' >
                                            <tr>

                                                <th class="sealrow">Buyer Dealer Name</th>
                                                <th class="sealrow">Buyer Name</th>
                                                {/* <th class="sealrow">Bid Type</th> */}
                                                <th class="sealrow">Proxy Bid Amount</th>
                                                <th class="sealrow">Date & Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dealerList.length > 0 ? dealerList.sort()
                                                .map((dealerList, index) =>
                                                    <tr key={index}>
                                                        <td>{dealerList.buyerdealername}</td>
                                                        <td>{dealerList.buyerName}</td>
                                                        {/* <td>{dealerList.type}</td> */}
                                                        <td>${dealerList.max_proxy_bid}</td>
                                                        <td>{formatTime(dealerList?.bid_date)}</td>
                                                    </tr>
                                                ) :
                                                <tr>
                                                    <td colspan="20" className="text-center bit-list">
                                                        <p>No Data Found</p>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>

                                    </table>
                                </div>
                            }
                            <div>


                                <div class="Close-info">
                                    <button className="cta-btns-primary" onClick={props.toggle}>Close</button>

                                </div>
                            </div>

                        </>
                    }
                </Modal.Body>
            </Modal>

        </div>
    );
};
export default ProxyBid;